<template>
  <div class="preview">
    <SectionTitle :title="title" />
    <div class="preview__wrapper">
      <PreviewItem :name="2" :proportion="29.17" :reverse="false" />
      <PreviewItem :name="1" :proportion="51.17" :reverse="true" />
      <PreviewItem :name="3" :proportion="19.53" :reverse="false" />
    </div>
  </div>
</template>

<script>
import SectionTitle from "./SectionTitle.vue";
import PreviewItem from "./PreviewItem.vue";

export default {
  components: {
    SectionTitle,
    PreviewItem,
  },
  data() {
    return {
      title: ["PREVIEW."],
    };
  },
};
</script>

<style lang="scss" scoped>
.preview {
  height: 100vh;
  position: relative;

  .title {
    z-index: 100;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    // z-index: -2;
  }
}
</style>
